module.exports = __webpack_public_path__ + "assets/img/banner.1a9031f7.jpg";